import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import AddUserIcon from "../icons/AddUserIcon";
import CreateLabelForm, { CreateLabelFormHandler } from "../forms/CreateLabelForm";
import PrimaryButton from "../PrimaryButton";
import { useCallback, useRef } from "react";
import { useMutation, useQueryClient } from "react-query";
import { TicketLabel } from "../../types/ticket.types";
import { createTicketLabel, updateTicketLabel } from "../../mutations/ticket_label.mutations";

type CreateLabelModalProps = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  defaultValue: TicketLabel | null;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function CreateLabelModal({
  isOpen,
  onClose,
  defaultValue,
}: CreateLabelModalProps) {
  const ref = useRef<CreateLabelFormHandler>(null);
  const queryClient = useQueryClient()
  const { mutate: mutateCreateTicketLabel } = useMutation(createTicketLabel, {
    onSuccess: () => {
      queryClient.invalidateQueries(["ticket_labels"]);
      onClose();
    },
  });
  const { mutate: mutateUpdateTicketLabel } = useMutation(updateTicketLabel, {
    onSuccess: () => {
      queryClient.invalidateQueries(["ticket_labels"]);
      onClose();
    },
  });
  const handleOnClick = useCallback(() => {
    if (ref.current) {
      if (ref.current.isValid()) {
        if (defaultValue) {
          mutateUpdateTicketLabel({ ...(ref.current.values() as TicketLabel), id: defaultValue.id })
        } else {
          mutateCreateTicketLabel(ref.current.values() as TicketLabel)
        }
      }
    }
  }, [mutateCreateTicketLabel, mutateUpdateTicketLabel, defaultValue])
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
      <ModalContent maxW={"none"} w="30vw">
        <ModalHeader>
          <AddUserIcon w="48px" h="48px" mr="8px"></AddUserIcon>
          { defaultValue ? 'Modifier un libellé' : 'Ajouter un libellé' }
        </ModalHeader>
        <ModalCloseButton onClick={onClose} />
        <ModalBody>
          <CreateLabelForm ref={ref} defaultValue={defaultValue}></CreateLabelForm>
        </ModalBody>
        <ModalFooter borderTop="solid 1px #E2E8F0">
          <PrimaryButton onClick={handleOnClick}>
            { defaultValue ? 'Sauvegarder': 'Ajouter' }
          </PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default CreateLabelModal;